"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentShareView = void 0;
var _react = require("react");
var _main = require("../../../main");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
const EnvironmentShareView = props => {
  const {
    environmentTitle,
    productInfo,
    onClose
  } = props;
  const {
    getLabel,
    setSliderView
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const defaultShareURL = 'https://myofek.cet.ac.il';
  const defaultShareMessageText = getLabel('share_env').replace('{X}', `"${productInfo.ProductName}"`).replace('{Y}', `"${environmentTitle}"`);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "environmentShareView",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.SocialShare, {
      layout: "inline",
      shareList: ['link', 'whatsapp', 'teams', 'googleClassroom'],
      title: environmentTitle,
      whatsappText: productInfo.shareMessageLineText ?? defaultShareMessageText,
      onBack: () => {
        setSliderView('environmentSaved');
      },
      onClose: onClose,
      url: productInfo.ProductURL ?? defaultShareURL
    })
  });
};
exports.EnvironmentShareView = EnvironmentShareView;